import { CircularProgress, Typography, Grid } from '@mui/material';
import { useTranslation } from 'react-i18next';

//TODO: evaluate if this should be moved to the wareclouds-ui library
export default function SmallSpinner() {
  const { t } = useTranslation(['glossary']);

  return (
    <Grid container justifyContent="center" alignItems="center" gap={1}>
      <CircularProgress size={24} />
      <Typography fontWeight={'bold'}>
        {t('loading', { ns: 'glossary' })}...
      </Typography>
    </Grid>
  );
}
